import React, { useEffect, useRef, useState } from "react";
import { useLayout } from "../../hooks/useLayout";

import { Dialog } from "@in/component-library";
import { Button, Grid, GridItem, Text } from "@innovationnorway/lighthouse-components";
import useSWR from "swr";
import { getUserAccounts } from "../../apis/getUserAccounts";
import VerifyEmailConfirmationCode from "../verify-email-confirmation-code/verify-email-confirmation-code";
import VerifyEmailForm from "../verifyEmailForm/verifyEmailForm";

interface AddAccountModalProps {
  accountPublicId: string;
  accountName: string;
  onClose: (addedAccountId: string) => void;
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}

const AddAccountModal = ({ accountPublicId, accountName, onClose, showModal, setShowModal }: AddAccountModalProps) => {
  const { data: userAccounts } = useSWR(`userAccounts`, getUserAccounts);
  const { translations } = useLayout();
  const dialogRef = useRef<HTMLDialogElement>(null);

  const [verificationSent, setVerificationSent] = useState<boolean>(false);
  const [emailIsVerified, setEmailIsVerified] = useState<boolean>(false);
  const [email, setEmail] = useState<string>();
  const [phoneNumber, setPhoneNumber] = useState<string>();

  useEffect(() => {
    if (userAccounts) {
      const userAccount = userAccounts.find((userAccount) => userAccount.emailVerified === true);
      setEmail(userAccount?.emailAddress);
      setPhoneNumber(userAccount?.phoneNumber);
    }
  }, [accountPublicId]);

  useEffect(() => {
    if (showModal) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [showModal]);

  const close = () => {
    onClose(
      userAccounts?.find((a) => a.account.publicId != accountPublicId && a.emailVerified)?.account.publicId || ""
    );
    setShowModal(false);
  };

  const verificationCreated = (verified: boolean, verificationSent: boolean, email: string, phoneNumber: string) => {
    setVerificationSent(verificationSent);
    setEmailIsVerified(verified);
    setEmail(email);
    setPhoneNumber(phoneNumber);
  };

  return (
    <Dialog
      title={
        emailIsVerified
          ? `${translations.verifyEmailAccountAddedSuccessfully} ${accountName}`
          : `${translations.verifyEmailConfirmContactInformation} ${accountName}`
      }
      ref={dialogRef}
      onClose={close}
      closeButton={{
        onClick: () => dialogRef.current?.close(),
        "aria-label": translations.close
      }}
    >
      {!emailIsVerified && !verificationSent && (
        <VerifyEmailForm
          accountPublicId={accountPublicId}
          onSuccess={verificationCreated}
          suggestedEmail={email}
          suggestedPhoneNumber={phoneNumber}
        />
      )}
      {!emailIsVerified && verificationSent && (
        <VerifyEmailConfirmationCode
          accountPublicId={accountPublicId}
          onSuccess={setEmailIsVerified}
          onCancel={() => {
            setVerificationSent(false);
            setEmailIsVerified(false);
          }}
          recipientEmail={email}
        />
      )}
      {emailIsVerified && (
        <Grid>
          <GridItem spanLarge={12} spanMedium={12} spanSmall={4}>
            <Text as="p">{translations.verifyEmailYouCanCloseWindow}</Text>
          </GridItem>
          <GridItem spanLarge={12} spanMedium={12} spanSmall={4}>
            <Button variant="primary" onClick={close}>
              {translations.close}
            </Button>
          </GridItem>
        </Grid>
      )}
    </Dialog>
  );
};
export default AddAccountModal;
